import { h } from 'preact';
import { useState } from 'preact/hooks';
import { IconClose, SizeChart } from 'utils/icon';

const SizePopup = ({ data, chartPopup, accordions = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openPopup = () => {
    setIsOpen(true);
    document.body.classList.add('overflow-y-hidden');
  };

  const closePopup = () => {
    setIsOpen(false);
    document.body.classList.remove('overflow-y-hidden');
  };

  if (!chartPopup || !data.sizeTable) return null;

  const parser = new DOMParser();
  const doc = parser.parseFromString(
    data.sizeTable?.value || data.sizeTable,
    'text/html',
  );
  const styleTags = doc.querySelectorAll('style');
  styleTags.forEach((tag) => {
    tag.remove();
  });
  const sizeChartHTMLString = doc.body.innerHTML;

  return (
    <div className={`size-chart ${accordions ? 'mb-[20px]' : ''}`}>
      <button className="flex items-center" type="button" onClick={openPopup}>
        <SizeChart />
        <span className="pl-1 body-3--underline text-text-default">
          {' '}
          {window.TMW.Strings.product.sizeBtnTitle}
        </span>
      </button>
      {isOpen && (
        <div>
          <div
            className="size-chart--popup fixed bottom-0 left-0 right-0 bg-white
                      sm:pr-5 pl-5 pt-6 pb-5 z-[1000]
                      lg:bottom-auto lg:top-1/2 lg:right-auto lg:left-1/2
                      lg:-translate-x-1/2 lg:-translate-y-1/2 lg:pb-5 lg:pt-6
                      lg:w-[795px] max-h-full transition-opacity
                      overflow-y-auto duration-300 opacity-100"
          >
            <button
              type="button"
              onClick={closePopup}
              className="absolute cursor-pointer right-5 top-6 w-4 h-4"
            >
              <IconClose />
            </button>
            <div className="h3 mb-6">
              {' '}
              {window.TMW.Strings.product.sizeTableTitle}
            </div>
            <div className="table-scroll overflow-x-auto">
              <div
                className="[&>li]:body-3 size-popup-container"
                dangerouslySetInnerHTML={{ __html: sizeChartHTMLString }}
              ></div>
            </div>
          </div>
          <div className="fixed top-0 bottom-0 left-0 right-0 bg-gray-900 opacity-20 z-[999]"></div>
        </div>
      )}
    </div>
  );
};

export default SizePopup;
